import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    //My Attendance > Calendar
    async getCalendarByUser(currentDate) {
        try{                
            const response = await axios.get(`MyAttendance/calendar/${currentDate}`, {
                headers: {
                    'page_key': pageKeys.mycalendar
                }
            })             
            return response
        }catch (error){
            console.log('axios getCalendarByUser error: ' + error)
            throw error
        }
    },
    async clockIn(data) {
        try{            
            const response = await axios.post(`Attendance/clockin`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })            
            return response
        }catch (error){
            console.log('axios clockIn error: ' + error)
            throw error
        }
    },
    async clockOut(data) {
        try{            
            const response = await axios.post(`Attendance/clockout`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })          
            return response
        }catch (error){
            console.log('axios clockOut error: ' + error)
            throw error
        }
    },
    async getTodayPerUser() {
        try{                
            const response = await axios.get(`Attendance/today`)            
            return response
        }catch (error){
            console.log('axios getTodayPerUser error: ' + error)
            throw error
        }
    },
    async getThisMonthPerUser() {
        try{                 
            const response = await axios.get(`Attendance/thismonth`)            
            return response
        }catch (error){
            console.log('axios getThisMonthPerUser error: ' + error)
            throw error
        }
    },  
}